var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

// //add listener to trigger path animation
var observer = new IntersectionObserver(intersectionCallback, {threshold: 0.5});
var target = document.querySelector("#graphic-animated");
observer.observe(target);

function intersectionCallback(entries, observer){
  entries.forEach(entry=> {
    if(entry.isIntersecting){
      console.log("intersect!");
      entry.target.classList.add("active");
    }
  })
}

var onWindowLoaded = function() {
  pym.then(child => {
      child.sendHeight();

      // child.onMessage("on-screen", function(bucket) {
      //     ANALYTICS.trackEvent("on-screen", bucket);
      // });
      // child.onMessage("scroll-depth", function(data) {
      //     data = JSON.parse(data);
      //     ANALYTICS.trackEvent("scroll-depth", data.percent, data.seconds);
      // });

      window.addEventListener("resize", () => child.sendHeight());
  });
}

// wait for images to load
window.onload = onWindowLoaded;
